import * as styles from "./VolunteerVacancyCard.module.scss";

import cx from "clsx";
import React from "react";
import LinkNoStyle from "../../../components/common/LinkNoStyle/LinkNoStyle";
import { Star } from "../../common/Icons";
export interface VolunteerVacancyCardProps {
	url: string;
	volunteerRole: string;
	city: string;
	distance?: number;
	latitude: string;
	longitude: string;
	isNew?: boolean;
	date?: string;
	linkText?: string;
	linkClassName?: string;
	vacancyLocation?: {
		isNational: boolean;
		city: string;
		longitude: string;
		latitude: string;
	};
}

export const VolunteerVacancyCard: React.FC<VolunteerVacancyCardProps> = ({
	url,
	volunteerRole,
	city,
	distance,
	isNew,
	linkText,
	linkClassName,
	vacancyLocation,
}) => {
	const theCity = city || vacancyLocation?.city;
	return (
		<LinkNoStyle className={styles.vacancycardcontainer} to={url}>
			<div className={styles.vacancycontainer}>
				<div className={styles.leftcolumn}>
					<div className={styles.vacancyrole}>{volunteerRole}</div>

					<div className={styles.vacancylocation}>{theCity}</div>
				</div>
				<div className={styles.rightcolumn}>
					{isNew && (
						<div className={styles.newlabel}>
							<Star height="14px" width="14px" />
							NEW
						</div>
					)}
					{!!distance && (
						<div className={styles.distance}>{`${distance?.toFixed(
							1,
						)} miles`}</div>
					)}
					{vacancyLocation?.isNational && (
						<div className={styles.nationallabel}>NATIONAL</div>
					)}
					<div className={styles.extrainfo}>
						<div className={cx(styles.linkwording, linkClassName)}>
							{linkText || "More information"}
						</div>
					</div>
				</div>
			</div>
		</LinkNoStyle>
	);
};

export default VolunteerVacancyCard;
